/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}.error-message[_ngcontent-%COMP%]{color:#f44336;font-size:12px;margin-top:8px}  .mat-dialog-content{padding:20px 24px}  .mat-dialog-actions{padding:8px 24px 24px;-webkit-box-pack:end;justify-content:flex-end}"];
export { styles as styles };
